import React from 'react';

import type { PromotedEntities, UnionsMenuLayerItem } from '../../types';

import { UnionMenuItem } from './UnionMenuItem';

type UnionsMenuItemsProps = {
  list: UnionsMenuLayerItem[];
};

const isPromotedTournament = (entry: UnionsMenuLayerItem) => {
  return entry.entity.promotionLevel > 0 && 'tournamentUnionId' in entry.entity;
};

const isPromotedUnion = (entry: UnionsMenuLayerItem) => {
  return entry.entity.promotionLevel > 0 && 'unionId' in entry;
};

const processPromotedEntities = (
  entry: UnionsMenuLayerItem,
  promotedEntities: PromotedEntities,
) => {
  if ('tournamentUnionId' in entry.entity && isPromotedTournament(entry)) {
    const promotedEntityIdKey = `union-${entry.entity?.tournamentUnionId}`;
    Object.assign(promotedEntities, { [promotedEntityIdKey]: null });
    return promotedEntityIdKey;
  }

  if ('unionId'in entry && isPromotedUnion(entry)) {
    const promotedEntityIdKey = `union-${entry?.unionId}`;
    Object.assign(promotedEntities, { [promotedEntityIdKey]: null });
    return promotedEntityIdKey;
  }

  return '';
};

export const UnionsMenuItems: React.FC<UnionsMenuItemsProps> = ({ list }) => {
  const promotedEntities: PromotedEntities = {};

  return (
    <>
      {list.map((entry) => {
        const key = entry?.dataGaValues ? `${entry.key}-${entry?.dataGaValues['data-ga-event']}` : entry.key;
        const promotedEntityId = processPromotedEntities(entry, promotedEntities);

        return (
          <UnionMenuItem entry={entry}
                         promotedEntities={promotedEntities}
                         promotedEntityId={promotedEntityId}
                         key={key} />
        );
      })}
    </>
  );
};
